import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Content = styled.div`
  padding: 40px 50px;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 25px 20px 20px;
  }
`;

export const IconBgWrapper = styled.div<{ $hasBg: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ $hasBg }) =>
    $hasBg &&
    css`
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.palette.secondary.background};

      @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        width: 35px;
        height: 35px;
      }
    `}
`;

export const IconRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 20px;
  }
`;

export const Title = styled(Typography.Header)`
  margin-bottom: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

export const Description = styled(Typography.Body)`
  margin-bottom: 30px;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.secondary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
    margin-bottom: 20px;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
`;
